// Bridges the balance an original game reports through its SDK (casino game
// page) to the header balance (layout-ui). The header is a layout sibling of
// the game page, not a parent, so the numbers travel over a window event — the
// event name is the shared contract, both sides use these helpers.
const GAME_BALANCE_EVENT = "game:balance";

export type GameBalance = {
  // Set while a round is in progress: the wallet is frozen until it settles.
  isLocked: boolean;
  // Amount in the base currency, or undefined when the game reports no balance.
  balance?: number;
};

export const dispatchGameBalance = (detail: GameBalance): void => {
  window.dispatchEvent(new CustomEvent(GAME_BALANCE_EVENT, { detail }));
};

export const onGameBalance = (
  handler: (detail: GameBalance) => void,
): (() => void) => {
  const listener = (event: Event) =>
    handler((event as CustomEvent<GameBalance>).detail);

  window.addEventListener(GAME_BALANCE_EVENT, listener);
  return () => window.removeEventListener(GAME_BALANCE_EVENT, listener);
};
